(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerSetCurrentYear = footerSetCurrentYear;
function footerSetCurrentYear() {
  var yearElement = document.querySelector('[data-footer="year"]');
  if (yearElement) {
    yearElement.textContent = new Date().getFullYear();
  }
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerBtnMobile = headerBtnMobile;
var _outsideClick = require("../helpers/outsideClick.js");
function headerBtnMobile() {
  // btn mobile
  var headerBtnMobile = document.querySelector('[data-header="btn-mobile"]');
  if (headerBtnMobile) {
    var handleClickHeaderBtn = function handleClickHeaderBtn(event) {
      event.preventDefault();
      html.classList.toggle("overflow-mobile");
      headerNav.classList.toggle("active");
      headerBtnMobile.classList.toggle("active");
      headerOverlay.classList.toggle("active");
      (0, _outsideClick.outsideClick)({
        element: headerNav,
        events: ["click"],
        callback: function callback() {
          html.classList.remove("overflow-mobile");
          headerNav.classList.remove("active");
          headerBtnMobile.classList.remove("active");
          headerOverlay.classList.remove("active");
        }
      });
    };
    var html = document.documentElement;
    var headerNav = document.querySelector('[data-header="nav"]');
    var headerOverlay = document.querySelector('[data-header="overlay"]');
    headerBtnMobile.addEventListener("click", handleClickHeaderBtn);
  }
}

},{"../helpers/outsideClick.js":8}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerFixedOnScroll = headerFixedOnScroll;
function headerFixedOnScroll() {
  var header = document.querySelector('[data-header="header"]');
  if (header) {
    var handleWindowScroll = function handleWindowScroll() {
      var windowScroll = window.scrollY;
      if (windowScroll > 400) {
        header.classList.add("fixed");
      } else if (header.classList.contains("fixed")) {
        header.classList.remove("fixed");
      }
    };
    handleWindowScroll();
    window.addEventListener("scroll", handleWindowScroll);
  }
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerInternLinks = headerInternLinks;
function headerInternLinks() {
  var internLinks = document.querySelectorAll("[data-header=\"nav\"] a[href^=\"#\"]");
  if (internLinks.length) {
    var closeMenuMobile = function closeMenuMobile() {
      var headerBtnMobile = document.querySelector('[data-header="btn-mobile"]');
      var isScreenMaxWidth991px = window.matchMedia("(max-width: 991px)").matches;
      if (isScreenMaxWidth991px) {
        headerBtnMobile.click();
      }
    };
    internLinks.forEach(function (link) {
      link.addEventListener("click", closeMenuMobile);
    });
  }
}

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerLinkActiveOnScroll = headerLinkActiveOnScroll;
function headerLinkActiveOnScroll() {
  var sections = document.querySelectorAll("[data-section]");
  var linksIntern = document.querySelectorAll('[data-header="nav"] a[class^="link-"]');
  if (sections.length && linksIntern) {
    var handleScroll = function handleScroll() {
      sections.forEach(function (section) {
        var sectionTarget = section[0] ? section[0] : section;
        if (sectionTarget) {
          var sectionTop = sectionTarget.getBoundingClientRect().top;
          var isTopSectionVisible = sectionTop - scroll40Percentage < 0;
          var dataSection = sectionTarget.dataset.section;
          if (isTopSectionVisible && !sectionTarget.classList.contains("active")) {
            sectionTarget.classList.add("active");
            if (dataSection) {
              var linkTarget = document.querySelector("[data-header=\"nav\"] .link-".concat(dataSection));
              linksIntern.forEach(function (link) {
                if (link === linkTarget) {
                  link.classList.add("active");
                } else if (link.classList.contains("active")) {
                  link.classList.remove("active");
                }
              });
            } else {
              linksIntern.forEach(function (link) {
                return link.classList.remove("active");
              });
            }
          } else if (!isTopSectionVisible && sectionTarget.classList.contains("active")) {
            sectionTarget.classList.remove("active");
            var sectionsUpdated = document.querySelectorAll("[data-section]");
            var sectionsActive = Array.from(sectionsUpdated).filter(function (section) {
              if (section.classList.contains("active")) return section;
            });
            var lastSectionActive = sectionsActive[sectionsActive.length - 1];
            var lastSectionActiveData = lastSectionActive.dataset.section;
            if (lastSectionActiveData) {
              var _linkTarget = document.querySelector(".link-".concat(lastSectionActiveData));
              linksIntern.forEach(function (link) {
                if (link === _linkTarget) {
                  link.classList.add("active");
                } else if (link.classList.contains("active")) {
                  link.classList.remove("active");
                }
              });
            } else {
              linksIntern.forEach(function (link) {
                return link.classList.remove("active");
              });
            }
          }
        }
      });
    };
    var scroll40Percentage = window.innerHeight * 0.4;
    handleScroll();
    window.addEventListener("scroll", handleScroll);
  }
}

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideBtnWhatsOnFooter = hideBtnWhatsOnFooter;
function hideBtnWhatsOnFooter() {
  var btnWhats = document.querySelector('[data-whats="btn"]');
  var footer = document.querySelector("[data-footer]");
  if (btnWhats && footer) {
    var changeOnScroll = function changeOnScroll() {
      var footerTop = footer.getBoundingClientRect().top;
      var isFooterVisible = footerTop - scroll90Percent < 300;
      if (isFooterVisible) {
        btnWhats.classList.add("hide");
      } else if (btnWhats.classList.contains("hide")) {
        btnWhats.classList.remove("hide");
      }
    };
    var scroll90Percent = window.innerHeight * 0.95;
    window.addEventListener("scroll", changeOnScroll);
  }
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStoreOpen = isStoreOpen;
function isStoreOpen() {
  var storeStatusText = document.querySelectorAll('[data-store-status="text"]');
  var storeStatusCircle = document.querySelectorAll('[data-store-status="circle"]');
  if (storeStatusText.length && storeStatusCircle.length) {
    var storeOpenDays = [1, 2, 3, 4, 5, 6];
    var storeOpenHours = {
      hoursWeekend: [8, 20],
      hoursSaturday: [9, 15]
    };
    var dateNow = new Date();
    var dayNow = dateNow.getDay();
    var isDayWeekStoreOpen = storeOpenDays.indexOf(dayNow);
    if (isDayWeekStoreOpen !== -1) {
      var storeOpenHoursToday = dayNow === 6 ? storeOpenHours.hoursSaturday : storeOpenHours.hoursWeekend;
      var timeHoursNow = dateNow.getUTCHours() - 3;
      var isStoreOpenNow = timeHoursNow >= storeOpenHoursToday[0] && timeHoursNow < storeOpenHoursToday[1];
      if (!isStoreOpenNow) {
        storeStatusText.forEach(function (text) {
          return text.innerText = "Fechado";
        });
        storeStatusCircle.forEach(function (circle) {
          return circle.classList.remove("active");
        });
      }
    } else {
      storeStatusText.forEach(function (text) {
        return text.innerText = "Fechado";
      });
      storeStatusCircle.forEach(function (circle) {
        return circle.classList.remove("active");
      });
    }
  }
}

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outsideClick = outsideClick;
function outsideClick(_ref) {
  var element = _ref.element,
    events = _ref.events,
    callback = _ref.callback;
  var html = document.documentElement;
  var outside = "data-outside";
  if (!element.hasAttribute(outside)) {
    events.forEach(function (userEvent) {
      setTimeout(function () {
        html.addEventListener(userEvent, handleOutsideClick);
      });
    });
    element.setAttribute(outside, "");
  }
  function handleOutsideClick(event) {
    if (!element.contains(event.target)) {
      element.removeAttribute(outside);
      events.forEach(function (userEvent) {
        html.removeEventListener(userEvent, handleOutsideClick);
      });
      callback();
    }
  }
}

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servicesOnHover = servicesOnHover;
function servicesOnHover() {
  var servicesItems = document.querySelectorAll('[data-services="item"]');
  var isMin992 = window.matchMedia("(max-width: 600px)");
  if (servicesItems.length) {
    var handleServicesItemMouseEnter = function handleServicesItemMouseEnter() {
      var isTargetElementActive = this.classList.contains("hover");
      if (!isTargetElementActive) {
        var oldElementActive = Array.from(servicesItems).filter(function (item) {
          return item.classList.contains("hover");
        });
        if (oldElementActive[0]) {
          oldElementActive[0].classList.remove("hover");
        }
        this.classList.add("hover");
      }
    };
    servicesItems.forEach(function (item) {
      item.addEventListener("mouseenter", handleServicesItemMouseEnter);
    });
  }
}

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servicesModal = servicesModal;
function servicesModal() {
  var openButton = document.querySelector('[data-modal="open"]');
  var closeButton = document.querySelector('[data-modal="close"]');
  var modal = document.querySelector('[data-modal="wrapper"]');
  var modalBox = document.querySelector('[data-modal="wrapper"] .modal-box');
  if (openButton && closeButton && modal) {
    var showModal = function showModal(e) {
      e.preventDefault();
      html.classList.add("overflow-mobile");
      modal.classList.add("active");
      modalBox.classList.add("active");
    };
    var hideModal = function hideModal(e) {
      e.preventDefault();
      html.classList.remove("overflow-mobile");
      modalBox.classList.remove("active");
      setTimeout(function () {
        modal.classList.remove("active");
      }, 380);
    };
    var clickOutsideModal = function clickOutsideModal(e) {
      if (e.target === this) {
        hideModal(e);
      }
    };
    var html = document.documentElement;
    openButton.addEventListener("click", showModal);
    closeButton.addEventListener("click", hideModal);
    modal.addEventListener("click", clickOutsideModal);
  }
}

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servicesSlider = servicesSlider;
function servicesSlider() {
  var slider = new Swiper('[data-services="slider"]', {
    slidesPerView: 1.2,
    spaceBetween: 24,
    loop: false,
    navigation: {
      prevEl: '[data-services="btn-prev"]',
      nextEl: '[data-services="btn-next"]'
    },
    breakpoints: {
      600: {
        spaceBetween: 32,
        slidesPerView: 1.6
      },
      767: {
        slidesPerView: 2.4
      },
      992: {
        slidesPerView: 3
      },
      1280: {
        slidesPerView: 4
      }
    }
  });
}

},{}],12:[function(require,module,exports){
"use strict";

var _headerFixed = require("./modules/global/headerFixed");
var _headerLinkActiveOnScroll = require("./modules/global/headerLinkActiveOnScroll");
var _headerBtnMobile = require("./modules/global/headerBtnMobile");
var _headerInternLinks = require("./modules/global/headerInternLinks");
var _isStoreOpen = require("./modules/global/isStoreOpen");
var _hideBtnWhatsOnFooter = require("./modules/global/hideBtnWhatsOnFooter");
var _servicesSlider = require("./modules/servicesSlider");
var _servicesItemOnHover = require("./modules/servicesItemOnHover");
var _servicesModal = require("./modules/servicesModal");
var _footerSetCurrentYear = require("./modules/footerSetCurrentYear");
(0, _headerFixed.headerFixedOnScroll)();
(0, _headerLinkActiveOnScroll.headerLinkActiveOnScroll)();
(0, _headerBtnMobile.headerBtnMobile)();
(0, _headerInternLinks.headerInternLinks)();
(0, _isStoreOpen.isStoreOpen)();
(0, _hideBtnWhatsOnFooter.hideBtnWhatsOnFooter)();
(0, _servicesSlider.servicesSlider)();
(0, _servicesItemOnHover.servicesOnHover)();
(0, _servicesModal.servicesModal)();
(0, _footerSetCurrentYear.footerSetCurrentYear)();
window.addEventListener("load", function () {
  var isScreenWidthMin992 = window.matchMedia("(min-width: 992px)");
  var offsetValue = isScreenWidthMin992 ? 300 : 100;
  AOS.init({
    once: true,
    duration: 900,
    offset: offsetValue
  });
});

},{"./modules/footerSetCurrentYear":1,"./modules/global/headerBtnMobile":2,"./modules/global/headerFixed":3,"./modules/global/headerInternLinks":4,"./modules/global/headerLinkActiveOnScroll":5,"./modules/global/hideBtnWhatsOnFooter":6,"./modules/global/isStoreOpen":7,"./modules/servicesItemOnHover":9,"./modules/servicesModal":10,"./modules/servicesSlider":11}]},{},[12]);
